<template>
    <div class="carousel" :class="classes">
        <div ref="swiper" class="swiper-container carousel-container" :style="{'overflow': overflow}">
            <div class="carousel-wrapper swiper-wrapper">
                <div class="carousel-slide swiper-slide" v-for="(item, i) in items" :key="i">
                    <slot name="slide" :item="item"></slot>
                </div>
            </div>
            <div v-if="hasPagination" class="pagination">
                <span class="bullet" :class="{'active': activePaginationItem === 0}"></span>
                <span class="bullet" :class="{'active': activePaginationItem === 1}"></span>
                <span class="bullet" :class="{'active': activePaginationItem === 2}"></span>
                <span class="bullet" :class="{'active': activePaginationItem === 3}"></span>
            </div>
        </div>
        <navigation v-if="showNavigation" @slide-prev="slidePrev" @slide-next="slideNext"></navigation>
    </div>
</template>

<script>
import Swiper, { Autoplay } from 'swiper';
import Navigation from "./Navigation";

Swiper.use([Autoplay]);
export default {
    props: {
        image: {
            type: String,
            default: () => ''
        },
        classes: {
            type: String
        },
        items: {
            type: Object | Array
        },
        options: {
            type: Object
        },
        showNavigation: {
            type: Boolean,
            default: () => true,
        },
        showPagination: {
            type: Boolean,
            default: () => true,
        },
        swiperOption: {
            default: () => ({
                navigation: {
                    nextEl: '.navigation-next',
                        prevEl: '.navigation-prev',
                }
            })
        },
    },
    components: {
        Navigation
    },
    data() {
        return {
            swiper: null,
            overflow: 'hidden',
        }
    },
    computed: {
        activeIndex() {
            return this.swiper ? this.swiper.realIndex : 0;
        },
        activePaginationItem() {
            return this.activeIndex - Math.floor(this.activeIndex / 4) * 4;
        },
        changeOverflow() {
            let classes = this.classes ? this.classes.split(' ') : [];

            return classes.includes('slides-3') || classes.includes('slides-4') || classes.includes('slides-5');
        },
        hasPagination() {
            return this.$q.platform.is.mobile && this.showPagination;
        }
    },
    mounted() {
        const _this = this;

        let index = null;
        if (this.image) {
            index = _.findIndex(this.items, (item) => item.image === this.image);

            if (index !== -1) {
                this.swiperOption['initialSlide'] = index;
            }
        }

        _this.$nextTick(function () {
            _this.swiper = new Swiper(_this.$refs.swiper, {..._this.swiperOption, ..._this.options});
            _this.swiper.on('slideChange', function (swiper) {
                _this.$emit('slideChange', swiper.realIndex);
            });

            if (this.changeOverflow) {
                _this.overflow = 'visible';
                _this.swiper.on('slideChangeTransitionEnd', function () {
                    _this.overflow = 'visible';
                });
            }
        });
    },
    updated() {
        this.update();
    },
    methods: {
        update() {
            if (this.swiper) {
                this.swiper.update();
            }
        },
        slidePrev() {
            if (this.changeOverflow) {
                this.overflow = 'hidden';
            }
            this.swiper.slidePrev();
        },
        slideNext() {
            if (this.changeOverflow) {
                this.overflow = 'hidden';
            }
            this.swiper.slideNext();
        },
        slideTo(index) {
            this.swiper.slideTo(index, 1000, false);
        },
    }
}
</script>
